import { useRef } from 'react';
import classNames from 'classnames';
import Page from '../../components/Layout/Page';
import { getPageContent } from '../../api/pagesApi';
import { genShareConfig } from '../../components/Share/use-config-share';
import { serverSideTranslation } from '../../util/next';
import NewsGroup from '../../components/NewsGroup';
import { Image } from '../../components/Image';
import { Tooltips } from '../../components/Common/components/Tooltips';
import styles from './Algorithm.module.scss';
import { useScreenSize, BreakPoint } from '../../components/ScreenSize';
import { Decoration } from '../../modules/HomeBanner/Decoration';
import ConsultationModule from '../../components/ConsultationModule';

const homeMoImg = 'https://p0.meituan.net/smartvenus/226d7534be373471a80440202a20cc2264014.png';
const homeCenterPcImg = 'https://s3plus.meituan.net/smart/halfbg2.svg';
const homeCenterPcHoverImg = 'https://s3plus.meituan.net/smart/pc-bg.svg';
const homeLeftImg = 'https://s3plus.meituan.net/smart/left-trans.svg';
const homeRightImg = 'https://s3plus.meituan.net/smart/right2.svg';

const Algorithm = (props: any) => {
  const { _nextI18Next: i18n, pageContentData } = props;
  const { shareContent = {}, pageContent = {} } = pageContentData || {};
  const description =
    shareContent.shareDetail || '美团将依据各界意见，不断改进及公开算法相关举措，持续推动算法向上向善。';
  const title = shareContent.shareTitle || '算法公开';
  const { pageTitle, groupDataList, chatChannel, algorithmRulesGroupData, consultationGroupData } = pageContent;
  const {
    moduleTitle,
    titleMain,
    contentText1,
    contentText2,
    contentText3,
    contactTips,
    tel,
    email,
    officialAccount,
    accountInfo,
    bgUrl,
  } = chatChannel;
  const liRef = useRef<HTMLDivElement>(null);
  const { screen } = useScreenSize();
  const isMobile = screen === BreakPoint.md || screen === BreakPoint.sm;

  return (
    <Page description={description} title={title}>
      <div className="w-full bg-[#f7f8f9]">
        <section
          className={classNames(styles['newsroom-banner-box'], 'pt-15 xl:pt-20')}
          style={
            {
              '--auto-bg': `url(${homeMoImg})`,
              '--1024-bg': `url(${homeCenterPcImg})`,
              '--1024-hover-bg': `url(${homeCenterPcHoverImg})`,
            } as any
          }
        >
          <h1 className="mt-font mx-auto w-[303px] pt-[70px] text-center text-[24px] font-normal leading-[38px] text-[#111111] md:w-[908px] md:pt-[104px] md:text-[36px] md:leading-[56px]">
            {pageTitle}
          </h1>
          <Decoration className={styles.newsroomBannerLeft} lg={homeLeftImg} xl={homeLeftImg} />
          <Decoration className={styles.newsroomBannerRight} lg={homeRightImg} xl={homeRightImg} />
        </section>
        <div className="bg-white-homebg pb-[60px] pt-[50px] md:pb-[90px] md:pt-[68px]">
          <NewsGroup lanType={i18n.initialLocale} {...algorithmRulesGroupData} />
          {/* 新增：协商共治模块 */}
          <ConsultationModule {...consultationGroupData} />

          {groupDataList?.map((item: any) => {
            return <NewsGroup key={item.titleText} lanType={i18n.initialLocale} {...item} />;
          })}
          <div className="mx-5 mt-[50px] md:mt-[60px] lg:max-w-screen-xl lg:pt-0 l:mx-auto">
            <div className="text-lg font-medium leading-5 lg:text-2sm lg:leading-10">{moduleTitle}</div>
            <div className="relative mx-auto mt-[12px] max-w-screen-xl rounded-lg bg-white p-4 pb-[320px] md:mt-[20px] md:rounded-2xl md:p-[60px]">
              <div className="mtext-[20px] font-semibold leading-[28px] text-[#000000e6] md:text-[28px] md:font-medium md:leading-[40px]">
                {titleMain}
              </div>
              <div className="md:flex md:justify-between">
                <div className="mt-[10px] text-[12px] font-normal leading-[20px] leading-[24px] text-[#00000099] md:w-2/3 md:w-[731px] md:text-[16px]">
                  <div>{contentText1}</div>
                  <div>{contentText2}</div>
                  <div>{contentText3}</div>
                  <div className="mt-[30px] h-[1px] bg-[#e5e5e5] md:w-[705px]" />
                  <div className="mt-[30px]">{contactTips}</div>
                  <div className="mt-[10px] flex flex-col md:flex-row md:space-x-4">
                    <div className="mb-2 md:mb-0">{tel}</div>
                    <div className="hidden md:my-auto md:block md:h-[16px] md:w-[1px] md:bg-[#e7e8e9]" />
                    <div className="mb-2 md:mb-0">{email}</div>
                    <div className="hidden md:my-auto md:block md:h-[16px] md:w-[1px] md:bg-[#e7e8e9]" />
                    <div>
                      <span>{officialAccount}</span>
                      {isMobile ? (
                        <span className="rounded-[4.5px] border border-[0.25px] border-[rgba(17,25,37,0.45)] px-[12px] py-[4.5px]">
                          {accountInfo}
                        </span>
                      ) : (
                        <span ref={liRef} className="hover:text-black-dark lg:mb-40">
                          {accountInfo}
                          <Tooltips
                            className="lg:mb-[-10px]"
                            placement="right"
                            offset={[0, 10]}
                            triggerTarget={liRef}
                            content={
                              <div className="h-[100px]  w-[100px]">
                                <Image
                                  src="https://p0.meituan.net/smartvenus/f48f2015b1db8761881b1cba9cffc65727864.png"
                                  alt="logo"
                                  width={1}
                                  height={1}
                                />
                              </div>
                            }
                          >
                            <></>
                          </Tooltips>
                        </span>
                      )}
                    </div>
                  </div>
                </div>
                {/* 右侧图片 */}
                <div className="absolute bottom-0 left-0 right-0 h-[300px] w-full md:bottom-auto md:left-auto md:right-0 md:top-0 md:h-full md:w-[calc(33.33%-1.5rem)]">
                  <Image
                    src={bgUrl}
                    layout="fill"
                    objectFit="cover"
                    className="rounded-b-xl md:rounded-b-none md:rounded-r-2xl"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Page>
  );
};

export async function getServerSideProps({ locale, query }: any) {
  const pageContentParams = {
    uri: '/newsroom/algorithm',
    pageContentNo: query.pageContentNo,
    preview: query.preview,
  };
  const pageContentData = await getPageContent(pageContentParams, locale);
  return {
    props: {
      lxCustom: {
        cid: 'c_donation_rp6kszz2',
        locale,
        ...pageContentData?.shareContent,
      },
      pageContentData,
      ...genShareConfig(pageContentData),
      ...(await serverSideTranslation(locale, ['contactus', 'cookie', 'common'])),
    },
  };
}

export default Algorithm;
